import { render, staticRenderFns } from "./LiveCategoriesTable.vue?vue&type=template&id=319d8dba"
import script from "./LiveCategoriesTable.vue?vue&type=script&lang=js"
export * from "./LiveCategoriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports